import React, { useEffect, useState, useContext, useCallback } from 'react';
import { getFormsTree, deleteForm } from '../../api/aprvForms'; 
import { AuthContext } from '../../context/AuthContext';
import AprvFormsView from './AprvFormsView';
import AprvFormsEdit from './AprvFormsEdit';
import AprvFormsForm from './AprvFormsForm';
import './AprvFormsList.css';

function AprvFormsList() {
  const [formTree, setFormTree] = useState([]);
  const [selectedForm, setSelectedForm] = useState(null);
  const [rightPanel, setRightPanel] = useState(null); 
  const { token } = useContext(AuthContext);

  // ✅ 트리 새로고침 (백엔드 응답 그대로 사용)
  const refreshTree = useCallback(() => {
    if (!token) return;
    getFormsTree(token)
      .then(res => {
        const treeWithRoot = [{
          form_code: 'root',
          form_name: '전자결재',
          form_type: 'folder',
          children: res
        }];
        setFormTree(treeWithRoot);
      })
      .catch(err => console.error('결재양식 불러오기 실패:', err));
  }, [token]);

  useEffect(() => {
    refreshTree();
  }, [refreshTree]);

  // ✅ 트리 렌더링
  const renderTree = (nodes, isRoot = false) => (
    <ul className="aprv-tree">
      {nodes.map(node => (
        <li key={node.form_code} className={isRoot ? "root-node" : ""}>
          <span
            className={node.form_type?.toLowerCase() === 'form' ? "form-node" : "folder-node"}
            onClick={() => {
              //console.log("노드 클릭:", node.form_code, node.form_name, node.form_type);
              setSelectedForm(node);
              setRightPanel('view');
            }}
          >
            {node.form_type?.toLowerCase() === 'form'
              ? `📄 ${node.form_name} (${node.form_code})`
              : `📂 ${node.form_name}`}
          </span>
          {node.children?.length > 0 && renderTree(node.children)}
        </li>
      ))}
    </ul>
  );

  // ✅ 폴더 옵션 추출
  const getFolderOptions = (nodes) => {
    let options = [];
    nodes.forEach(node => {
      if (node.form_type?.toLowerCase() === 'folder') {
        options.push({ code: node.form_code, name: node.form_name });
        if (node.children?.length > 0) {
          options = options.concat(getFolderOptions(node.children));
        }
      }
    });
    return options;
  };

  const handleDeleteForm = async (formCode) => {
    console.log('formCode : ' + formCode);
    if (!window.confirm('정말 삭제하시겠습니까?')) return;
    try {
      await deleteForm(formCode, token);   // ✅ API 호출
      alert('결재양식이 삭제되었습니다');
      setRightPanel(null);                 // 오른쪽 패널 닫기
      refreshTree();                       // 트리 새로고침
    } catch (err) {
      console.error('결재양식 삭제 실패:', err);
      alert('삭제 중 오류가 발생했습니다');
    }
  };


  return (
    <div className="container mt-4">
      <h3>📑 결재양식 관리</h3>


      <div className="row mt-3">
        <div className="col-md-6">
          <div className="mb-3">
            <button className="btn btn-primary" onClick={() => setRightPanel('form')}>
              ➕ 양식 생성
            </button>
          </div>
          {renderTree(formTree, true)}
        </div>
        <div className="col-md-6 mt-n4">
          {rightPanel === 'view' && selectedForm && (
            <AprvFormsView
              form={selectedForm}
              token={token}
              onEdit={() => setRightPanel('edit')}
              onDelete={handleDeleteForm}
            />
          )}
          {rightPanel === 'edit' && selectedForm && (
            <AprvFormsEdit
              form={selectedForm}
              token={token}
              onCancel={() => setRightPanel('view')}
              onRefresh={refreshTree}
              folderOptions={[...getFolderOptions(formTree)]}
            />
          )}
          {rightPanel === 'form' && (
            <AprvFormsForm
              token={token}
              onCancel={() => setRightPanel(null)}
              onRefresh={refreshTree}
              folderOptions={[...getFolderOptions(formTree)]}
            />
          )}
          {!rightPanel && (
            <div className="text-muted">👈 결재양식을 클릭하거나 상단 버튼으로 생성하세요</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AprvFormsList;